import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  is_invoice_modal_open: false,
  selected_user_role: '',
  selected_group_manager: '',
  selected_associate_manager: '',
  selected_invoice: null,
  invoice_data: [
    {
      invoice_no: '152/Jan/PORTAL/2025',
      invoice_date: '14/01/2025, 04:23:00',
      job_no: '152',
      ref_no: '124241',
      job_type: 'Virtual Sample / Mock up',
      description: 'This invoice is towards Job #152, Ref # 124241',
      status: 'PAID',
    },
    {
      invoice_no: '153/Jan/PORTAL/2025',
      invoice_date: '14/01/2025, 04:23:00',
      job_no: '153',
      ref_no: '5577889',
      job_type: 'Recreation',
      description: 'This invoice is towards Job #153, Ref # 5577889',
      status: 'UNPAID',
    },
    {
      invoice_no: '154/Jan/PORTAL/2025',
      invoice_date: '14/01/2025, 04:23:00',
      job_no: '154',
      ref_no: '234322',
      job_type: 'Digitizing',
      description: 'This invoice is towards Job #154, Ref # 234322',
      status: 'PAID',
    },
    {
      invoice_no: '155/Jan/PORTAL/2025',
      invoice_date: '14/01/2025, 04:23:00',
      job_no: '155',
      ref_no: '667788',
      job_type: 'Vector',
      description: 'This invoice is towards Job #155, Ref # 667788',
      status: 'UNPAID',
    },
  ]
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setInvoiceModalOpen: (state, action) => {
      state.is_invoice_modal_open = action.payload;
    },
    setUserRole: (state, action) => {
      state.selected_user_role = action.payload;
    },
    setGroupManager: (state, action) => {
      state.selected_group_manager = action.payload;
    },
    setAssociateManager: (state, action) => {
      state.selected_associate_manager = action.payload;
    },
    setInvoiceDetails: (state, action) => {
      let filterInvoice = state.invoice_data;
      filterInvoice = filterInvoice.filter(item => item.invoice_no === action.payload);
      state.selected_invoice = filterInvoice.length > 0 ? filterInvoice[0] : null;
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  setInvoiceModalOpen,
  setUserRole,
  setGroupManager,
  setAssociateManager,
  setInvoiceDetails
} = invoiceSlice.actions;

export default invoiceSlice.reducer;